// src/components/Footer.tsx
import FerrozLogo from '../assets/partners/Logo_Ferroz.jpg';
import viteLogo from '../assets/partners/vite.svg';
import reactLogo from '../assets/partners/react.svg';
import algoLogo from '../assets/partners/Logo_Algorand.png';
import pytealLogo from '../assets/partners/Logo_Pyteal.png';
import vercelLogo from '../assets/partners/Logo_Vercel.png'; 
import imgbbLogo from '../assets/partners/Logo_ImgBB.png';
import sendpulseLogo from '../assets/partners/Logo_Sendpulse.png';
import moxLogo from '../assets/mox_start.png';
import "../styles/decoration/Footer.css";

const PartnerKeyText = (
    <span className="banner-text">
        <span className="key-item">
            <span className="key-label">Desarrollado por:</span> 
            <img src={FerrozLogo} alt="Ferroz Logo" className="inline-logo" />
        </span>
        <span className="key-item">
            <span className="key-label">Infraestructura de:</span> 
            <img src={viteLogo} alt="Vite Logo" className="inline-logo" /> 
            <img src={reactLogo} alt="React Logo" className="inline-logo" /> 
            <img src={algoLogo} alt="Algorand Logo" className="inline-logo" />
            <img src={vercelLogo} alt="Vercel Logo" className="inline-logo" />
            <img src={pytealLogo} alt="PyTeal Logo" className="inline-logo" />
        </span>
        <span className="key-item">
            <span className="key-label">Apoyos externos por:</span> 
            <img src={imgbbLogo} alt="ImgBB Logo" className="inline-logo" /> 
            <img src={sendpulseLogo} alt="SendPulse Logo" className="inline-logo" />
        </span>
        <span className="key-item">
            <span className="key-label">Financiado por:</span> 
            <img src={moxLogo} alt="Mox Logo" className="inline-logo" /> 
        </span>
    </span>
);

export default function Footer() {
    const currentYear = new Date().getFullYear();
    const TextBlock1 = <div className="intercalated-text-wrapper" key="text-block-key-1">{PartnerKeyText}</div>;
    const Separator1 = <div className="text-separator" key="separator-key-1"></div>;
    const TextBlock2 = <div className="intercalated-text-wrapper" key="text-block-key-2">{PartnerKeyText}</div>;
    const Separator2 = <div className="text-separator" key="separator-key-2"></div>;
    const finalSequence = [
        TextBlock1, 
        Separator1, 
        TextBlock2, 
        Separator2
    ];

    return (
        <footer className="footer">
        
        <div className="partner-banner-container">
            <div className="partner-logos">
                {finalSequence} 
            </div>
        </div>
        
        <div className="footer-content">
            <div className="footer-links">
                <a 
                    href="https://ferrozmonheleworks.sbs/politicas" 
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    Política de Privacidad
                </a>                 
                <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>              
                <a 
                    href="https://ferrozmonheleworks.sbs/terminos" 
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    Términos de Uso
                </a>
            </div>
            <p>&copy; {currentYear} Mox Holkan. Todos los derechos reservados.</p>
        </div>
        </footer>
    );
}